import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "sobrino_cart_v2";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const value = useMemo(() => {
    const add = (product, size, quantity = 1, color = "") => {
      const key = `${product.id}-${size}-${color}`;
      const image = product.color_images?.[color]?.[0] || product.images?.[0];
      setItems((prev) => {
        const found = prev.find((i) => i.key === key);
        if (found) return prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(i.quantity + quantity, 20) } : i));
        return [...prev, { key, product_id: product.id, name: product.name, image, price: product.price, size, color, quantity }];
      });
    };
    const setQty = (key, q) => setItems((prev) => (q <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(q, 20) } : i))));
    const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { items, add, setQty, remove, clear, count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
export const FREE_SHIPPING_FROM = 50;
export const SHIPPING_COST = 4.95;
